import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

export const PaginationWrapper = styled("div")({
  display: "flex",
  width: "100%",
  justifyContent: "center",
  marginBottom: "2rem",
});

export const TableGridItem = styled(Grid)({
  display: "flex", 
  marginBottom: "100px"
});
